import { render, staticRenderFns } from "./CurrentLicense.vue?vue&type=template&id=65210620&"
import script from "./CurrentLicense.vue?vue&type=script&lang=js&"
export * from "./CurrentLicense.vue?vue&type=script&lang=js&"
import style0 from "./CurrentLicense.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports